import { useAuth } from "../context/AuthContext";
import { canUseModule } from "../config/permissions";

// A page is shown only to the kind of account it is for: "platform" pages to the platform account, "vendor" pages to a vendor's staff whose role
// is allowed and (for a manager or user) whose permissions[] grant the module, "any" pages to every valid account. The server enforces the same
// on every API; this decides what the browser offers.
export function canOpenPage({ user, hasRole, allowedRoles, scope = "vendor", module }) {
  if (!user || user.scope === "invalid") return false;
  if (!hasRole(allowedRoles)) return false;
  if (scope === "any") return true;
  if (scope === "platform") return user.scope === "platform";
  return user.scope === "vendor" && (!module || canUseModule(user, module));
}

export default function ProtectedRoute({ allowedRoles, scope, module, children }) {
  const { user, hasRole } = useAuth();

  if (!canOpenPage({ user, hasRole, allowedRoles, scope, module })) {
    return (
      <section className="panel">
        <p className="error-state">
          {user?.scope === "platform" && scope === "vendor"
            ? "The platform account manages vendors and vendor users only. Sign in as a vendor account to work with business data."
            : "You do not have access to this page."}
        </p>
      </section>
    );
  }

  return children;
}
